import React from 'react';
import EpargneNette from '../../components/simulation/Panels/EpargneNette';
import Panel from './Panel';

class EpargneNettePanel extends Panel {
	constructor() {
		super();
		this.code = 'EPAR_NET';
		this.icon = {
			iconSet: 'Lucide',
			name: 'PiggyBank',
		};
		this.libelle = 'Epargne nette';
		this.size = 4;
		this.tooltip =
			"Capacité d'autofinancement des opérations d'investissement après remboursement du capital de la dette.";
	}

	getComponent = function getComponent(data: any): React.ReactElement {
		return <EpargneNette data={data} tooltip={this.tooltip} />;
	};
}

export default EpargneNettePanel;
